<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'DocumentTypeList' }" class="mb-1 btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
              <b-row>
                <b-col>
                  <DocumentTypeForm
                    v-if="item"
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations"
                    :initial-values="retrieved" />
                </b-col>
              </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DocumentTypeForm from './Form.vue'
// import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    DocumentTypeForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  // beforeCreate () {
  //  checkPagePermission('configuration', 'DocumentTypeUpdate')
  // },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'documenttype/update/isLoading',
      error: 'documenttype/update/error',
      deleteError: 'documenttype/del/error',
      deleteLoading: 'documenttype/del/isLoading',
      created: 'documenttype/create/created',
      deleted: 'documenttype/del/deleted',
      retrieved: 'documenttype/update/retrieved',
      updated: 'documenttype/update/updated',
      violations: 'documenttype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'DocumentTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'documenttype/create/reset',
      deleteItem: 'documenttype/del/del',
      delReset: 'documenttype/del/reset',
      retrieve: 'documenttype/update/retrieve',
      updateReset: 'documenttype/update/reset',
      update: 'documenttype/update/update',
      updateRetrieved: 'documenttype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this documenttype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.version) {
        this.retrieved.version = parseInt(this.retrieved.version)
      }
      if (this.retrieved.ordering) {
        this.retrieved.ordering = parseInt(this.retrieved.ordering)
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
